import { Props, LayoutProps } from './props'

export default ({ title, children }: Props): LayoutProps => {
  document.title = `${title} | WorkerSense`

  return { children }
}
